<template>
  <v-data-table
    :headers="headers"
    :items="rows"
    :loading="loading"
    loading-text="Загрузка... Пожалуйста подождите"
    :mobile-breakpoint="300"
    hide-default-footer
    :items-per-page="-1"
    class="px-5"
  >
    <template v-slot:item.company="{ item }">
      <router-link
        v-if="canOpen"
        class="text-primary"
        :to="{ name: 'clients-id', params: { id: item.id } }"
      >
        {{ item.company || '—' }}
      </router-link>
      <span v-else>{{ item.company || '—' }}</span>
    </template>

    <template v-slot:item.balance="{ item }">
      <span v-if="item.stats" :class="{ 'error--text': item.stats.totals.balance < 0 }">{{ item.stats.totals.balance }}</span>
      <span v-else-if="item.stock_balance != null">{{ item.stock_balance }}</span>
      <span v-else>—</span>
    </template>

    <template v-slot:item.buffer="{ item }">
      <span v-if="item.stats">{{ item.stats.bufferBalance }}</span>
      <span v-else>—</span>
    </template>

    <template v-slot:item.activity="{ item }">
      <CorpActivityChip :source="item" dash />
    </template>

    <template v-slot:no-data>
      <span v-if="error" class="error--text">{{ error }}</span>
      <span v-else>Корпоративных клиентов нет.</span>
    </template>
  </v-data-table>
</template>

<script>
import api from '@/common/api';
import { parseWalletStatistics } from '@/common/models/walletStatistics';
import { partnerIdOf } from '@/common/models/partnerTypes';
import CorpActivityChip from '@/components/clients/card/CorpActivityChip.vue';

// Корпоративные клиенты партнёра. Сам партнёр получает от сервера только своих, админ в карточке партнёра
// просит клиентов с этим супервизором.
export default {
  name: 'PartnerClients',
  components: { CorpActivityChip },
  props: {
    partnerId: { type: [Number, String], required: true },
    self: { type: Boolean, default: false },
  },
  data: () => ({
    clients: [],
    loading: false,
    error: '',
    headers: [
      { text: 'ID', value: 'id', width: '70px' },
      { text: 'Компания', value: 'company' },
      { text: 'Email', value: 'email' },
      { text: 'Общий остаток', value: 'balance', align: 'end' },
      { text: 'В буфере', value: 'buffer', align: 'end' },
      { text: 'Кабинет активен до', value: 'activity' },
    ],
  }),
  computed: {
    rows() {
      return this.clients.map((client) => ({ ...client, stats: parseWalletStatistics(client.wallet_statistics) }));
    },
    canOpen() {
      return this.$store.getters['auth/isAllowed']('view_corpclient');
    },
  },
  watch: {
    partnerId() {
      this.load();
    },
  },
  created() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      this.error = '';
      try {
        const response = await api.get('/users/corp_clients/', { params: { page_size: -1 }, timeout: 120000 });
        const list = Array.isArray(response) ? response : (response.results || []);
        // Сам партнёр получает от сервера только своих; у админа оставляем клиентов, где партнёр супервизор или реферал
        const mine = (client) => [client.supervisor, client.referrer]
          .some((link) => String(partnerIdOf(link)) === String(this.partnerId));
        this.clients = this.self ? list : list.filter(mine);
      } catch (e) {
        this.clients = [];
        this.error = 'Не удалось загрузить корпоративных клиентов';
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
